import styled, { css } from 'styled-components';
import { Icon } from 'src/components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const OptionContainer = styled.div<{
  $ruleBelow: boolean;
  $absolute?: boolean;
}>(
  ({ theme, $ruleBelow, $absolute }) => css`
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    position: relative;

    & > * {
      margin-inline-start: 0;
      margin-bottom: ${theme.sz.s4};
      margin-inline-end: ${theme.sz.s4};
    }

    width: 100%;
    min-height: ${theme.sz.s16};
    margin-bottom: ${theme.sz.s8};
    padding: 0 ${theme.sz.s4};
    ${$ruleBelow ? `border-bottom: ${theme.bo.mediumWidth} solid ${theme.co.secondary80}` : ''};
    margin-top: 0;

    ${
      $absolute &&
      css`
        position: absolute;
        top: 0;
      `
    }
  `,
);

export const OptionsRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    gap: ${theme.sz.s4};
  `,
);

export const OptionsBank = styled(OptionContainer)`
  flex: 1;
  min-width: 0;
  margin-bottom: 0;
`;

export const ClearButtonContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    justify-content: flex-end;
    padding-inline-end: ${theme.sz.s4};
    margin-bottom: ${theme.sz.s8};
  `,
);

export const ClearIcon = styled(Icon)(
  ({ theme }) => css`
    font-size: ${theme.sz.s8};
    margin-top: -${theme.sz.s2}; // to offset icon viewport
    color: ${theme.co.secondary10};

    & svg path {
      stroke: currentColor;
      stroke-width: 1.25;
      paint-order: stroke fill;
    }
  `,
);

export const ClearButton = styled.button(
  ({ theme }) => css`
    height: ${theme.sz.s16};
    aspect-ratio: 1;
    padding: 0;

    display: flex;
    justify-content: center;
    align-items: center;

    color: ${theme.co.secondary10};
    background: transparent;

    cursor: pointer;
    border: ${theme.bo.mediumWidth} solid ${theme.co.secondary80};
    box-shadow: 0 ${theme.sz.s1} 0 ${theme.co.secondary80};
    border-radius: ${theme.bo.medium};

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      transform: none;
      box-shadow: 0 ${theme.sz.s1} 0 ${theme.co.secondary80};
    }

    &:not(:disabled):active,
    &:not(:disabled):active:visited,
    &:not(:disabled):hover,
    &:not(:disabled):hover:visited {
      box-shadow: 0 ${theme.bo.veryThickWidth} 0 ${theme.co.secondary80};
      transform: translateY(-2px);
    }
  `,
);
